( function( $, document, window ) {
	'use strict';

	$( function() {
		const swiper = new Swiper('.js-case-study-carousel', {
			direction: 'horizontal',
			slidesPerView: 1,
			autoHeight: true,
			spaceBetween: 20,

			breakpoints: {
				640: {
					spaceBetween: 40,
				},
				768: {
					spaceBetween: 60,
				},
			},

			navigation: {
				nextEl: '.js-case-study-carousel-nav .js-carousel-nav-next',
				prevEl: '.js-case-study-carousel-nav .js-carousel-nav-prev',
			},

			on: {
				afterInit: function(swiper) {
					const slideTotal = swiper.slides.length;
					const slidePerView = swiper.params['slidesPerView'];

					if ( slidePerView >= slideTotal) {
						swiper.$el.find($('.js-case-study-carousel-nav').hide());
					}
				}
			}
		});

		$('.js-expand', swiper.$el).each( function() {
			const toggle = $('.js-expand-trigger', this);
			const content = $('.js-expand-body', this);
			const activeClass = 'case-study-products__list--active';
			const activeIconClass = 'is-active';

			let isOpen = true;

			toggle.on( 'click', function() {
				if (isOpen) {
					content.removeClass(activeClass);
					toggle.removeClass(activeIconClass);
				} else {
					content.addClass(activeClass);
					toggle.addClass(activeIconClass);
				}

				setTimeout(function() {
					swiper.updateAutoHeight(300);
				}, 300);

				isOpen = !isOpen;
			});
		});
	} );
} )( jQuery, document, window );
